let CoinMatchPosterPanel = require("activity/CoinMatchActivity/CoinMatchPosterPanel")
let CoinMatchConfig = require("activity/CoinMatchActivity/CoinMatchConfig")
let CoinMatchLogic = require("activity/CoinMatchActivity/CoinMatchLogic")
let CoinMatchManager = require("activity/CoinMatchActivity/CoinMatchManager")

CoinMatchFinalRewardPanel = xClass("CoinMatchFinalRewardPanel",CoinMatchPosterPanel, () => { return cc.CSLoader.createNode(CoinMatchConfig.poster.csb); })

CoinMatchFinalRewardPanel.preloadResPromise = CoinMatchPosterPanel.preloadResPromise

CoinMatchFinalRewardPanel.show = function(onShowSuccess, onShowFail, onPanelClose) {
    CoinMatchFinalRewardPanel.preloadResPromise()
        .then(()=> {
            let panel = CoinMatchFinalRewardPanel.create();
            panel.popup(true);
            if(onPanelClose != null)
                panel.on(BasePanelEvent.Close, onPanelClose);
            
            if (onShowSuccess != null)  
                onShowSuccess();
        })
        .catch((err)=> {
            console.error("CoinMatchFinalRewardPanel show failed.", err);
            LogToLogCenter(err);
            if (onShowFail != null) {
                onShowFail(err);
            }
        });
}

CoinMatchFinalRewardPanel.prototype.initDetail = function () {
    let list = CoinMatchConfig.poster.posterLayers;
    list.forEach((name)=> {
        let child = GetChildByPath(this, CoinMatchConfig.poster[name]);
        child.setVisible(false);
    });

    let [rewardType, rewardList] = CoinMatchManager.getInstance().getFinalReward();
    if (rewardType == null) {
        rewardList = CoinMatchManager.getInstance().getGainFinalReward();
        this.btnMain.setText(CoinMatchConfig.strings.finalGain);
        this.btnMain.setEnabled(false);
    }
        
    if (rewardList != null && rewardList[0] != null) {
        let item = rewardList[0];
        let icon = UIItemBuilder.createProp(item.itemId, item.num)[0];
        this.addChild(icon);
        icon.config = item;
        icon.setPosition(CoinMatchConfig.poster.rewardIcon.x, CoinMatchConfig.poster.rewardIcon.y);
    }
}

CoinMatchFinalRewardPanel.prototype.onMainBtnClick = function() {
    if (CoinMatchManager.getInstance().hasFinalReward()) {        
        let isBusy = CoinMatchLogic.getFinalReward(
            ()=> this.onClose(null, "main"),
            ()=> {
                if (!this.isClosed)
                    this.btnMain.setEnabledWithNotChange(true);
            }
        );
        if (!isBusy)
            this.btnMain.setEnabledWithNotChange(false);
    } else {
        this.onClose();
    }
}

module.exports = CoinMatchFinalRewardPanel